import React from "react";
import {observer} from "mobx-react";
import {useStores} from "../hooks/useStores";
import {useTranslation} from "react-i18next";
import ProfileInfo from '../components/ProfileInfo';
import ProfileConfig from '../components/ProfileConfig';

const Profile = observer(() => {
    const {t} = useTranslation();
    const {myTibStore, notificationStore} = useStores();
    const {notifications} = notificationStore;
    const {settings, profile} = myTibStore;

    return (
        <div data-testid="profile" className="profile-page">
            <div className="page-title-mobile">
                {t("profile")}
            </div>
            <div className="favs-container profile">
                <ProfileInfo profile={profile} notifications={notifications}/>
                <ProfileConfig settings={settings}/>
            </div>

        </div>
    );
});

export default Profile;